import React from 'react';

export default function About() {
    return (
        <div className="max-w-6xl mx-auto px-6 pt-24 pb-24 text-center">
            <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-[#f5f5f7]">
                About.
            </h1>
            <p className="mt-6 text-gray-400">
                Content pending. Please check back later.
            </p>
        </div>
    )
}
